import { useAuth } from "../context/AuthContext";
import api, { setupInterceptors } from "../utils/endpointsHelperFn/apiInterceptor";
import { useEffect, useRef } from "react";

const useInterceptor = () => {
  const { accessToken, refreshAccessToken, showAlert } = useAuth();

  const tokenRef = useRef(accessToken);

  useEffect(() => {
    tokenRef.current = accessToken; // Always update to the latest token
  }, [accessToken]);

  useEffect(() => {
    setupInterceptors(refreshAccessToken, tokenRef, showAlert);
  }, [refreshAccessToken, showAlert]); // Only depends on functions, not accessToken itself

  return api;
};

export default useInterceptor;
